var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2013_14227)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.4958 16V15.9993H16.4998V10.1313C16.4998 7.26065 15.8818 5.04932 12.5258 5.04932C10.9125 5.04932 9.82985 5.93465 9.38785 6.77398H9.34118V5.31732H6.15918V15.9993H9.47251V10.71C9.47251 9.31732 9.73651 7.97065 11.4612 7.97065C13.1605 7.97065 13.1858 9.55998 13.1858 10.7993V16H16.4958Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.763672 5.31799H4.08101V16H0.763672V5.31799Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.42133 0C1.36067 0 0.5 0.860667 0.5 1.92133C0.5 2.982 1.36067 3.86067 2.42133 3.86067C3.482 3.86067 4.34267 2.982 4.34267 1.92133C4.342 0.860667 3.48133 0 2.42133 0V0Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2013_14227"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.51024df1244d02d87cfcf87a9a9d63ac.svg";
export { ForwardRef as ReactComponent };